import React from "react";
import Icon from "@mdi/react";
import {mdiShippingPallet} from "@mdi/js";

// eslint-disable-next-line import/no-anonymous-default-export
export default ({ldm}: {ldm: Number | null}) => {
    if (!ldm) {
        return <></>;
    }

    return (
        <div className="text-light">
            <Icon path={mdiShippingPallet} size={1}/>
            <>{ldm} ldm</>
        </div>
    );
}